const formatter = new Intl.NumberFormat('fr', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: 'decimal'
});

export const balanceFormatter = formatter.format;
